import React from 'react';
import { useRouter as useNextRouter } from 'next/router';

import { createUrlParam } from '@projectaltair/gemini-fetcher';

type Name =
  | '404'
  | 'LinkageOTP'
  | 'LinkageOTPV1'
  | 'OneTimePaymentPhoneLogin'
  | 'LinkagePasscode'
  | 'LinkageConsent'
  | 'CloseAccountReason'
  | 'CloseAccountSuccess'
  | 'CloseAccountSuccessBackHome'
  | 'LinkageGeneralError'
  | 'RegistrationGeneralError'
  | 'RedirectHydra';

export interface Params {
  url?: string;
  name?: Name;
  query?: {
    [key: string]: string | number | string[] | boolean | undefined;
  };
  id?: string | number;
  pushType?: 'push' | 'replace';
}

export const generateUrl = ({ name, query, url = '' }: Params): string => {
  switch (name) {
    case '404':
      url = `/general-error`;
      break;
    case 'LinkageOTP':
      url = `${createUrlParam('/otp', query)}`;
      break;
    case 'LinkageOTPV1':
      url = `${createUrlParam('/v1.0/unlink/otp', query)}`;
      break;
    case 'OneTimePaymentPhoneLogin':
      url = '/one-time-payment';
      break;
    case 'LinkagePasscode':
      url = `${createUrlParam('/passcode', query)}`;
      break;
    case 'LinkageConsent':
      url = `${createUrlParam('/consent', query)}`;
      break;
    case 'CloseAccountReason':
      url = '/close-account/reason';
      break;
    case 'CloseAccountSuccess':
      url = '/close-account/success';
      break;
    case 'CloseAccountSuccessBackHome':
      url = 'https://virgoku.id/';
      break;
    case 'RedirectHydra':
      break;
    case 'LinkageGeneralError':
      url = `/general-error`;
      break;
    case 'RegistrationGeneralError':
      url = `/general-error`;
      break;
    default:
      break;
  }
  return url;
};

export const useRedirect = () => {
  const router = useNextRouter();
  const redirect = React.useCallback(
    ({ name, id, query, url, pushType = 'push' }: Params): void => {
      if (url) {
        router.push(url);
      } else {
        if (pushType === 'replace') {
          router.replace(generateUrl({ name, id, query }));
        } else {
          router.push(generateUrl({ name, id, query }));
        }
      }
    },
    [router],
  );
  const locationRedirect = React.useCallback((name: string, query?: any) => {
    window.location.href = createUrlParam(name, query);
  }, []);
  return {
    redirect,
    locationRedirect,
  };
};

export const coBrandPath = {
  tnc: '/r/onboarding/static/syarat-dan-ketentuan-cobranding',
  privacyPolicy: '/r/onboarding/static/kebijakan-privasi',
  registrationConfirmation: '/vip/v1.0/registration/confirmation',
  registrationValidateOtp: '/vip/v1.0/registration/otp/verify',
  registrationCreatePasscode: '/vip/v1.0/registration/passcode/create',
  linkageConsent: '/vip/v1.0/linkage/consent',
  linkageConfirmation: '/vip/v1.0/linkage/confirmation',
  linkageValidateOtp: '/vip/v1.0/linkage/otp/verify',
  linkageValidatePasscode: '/vip/v1.0/linkage/passcode/verify',
  kycEKtpCapture: '/vip/v1.0/kyc/ektp/capture',
  kycEKtpEdit: '/vip/v1.0/kyc/ektp/edit',
  kycSelfie: '/vip/v1.0/kyc/selfie',
  kycFinish: '/vip/v1.0/kyc/finish',
  unlinkageValidatePasscode: '/vip/v1.0/unlinkage/passcode/verify',
  helpCenter: '/vip/v1.0/help-center',
};
